import { Pipe, PipeTransform } from '@angular/core';
import { AdminPanelCorrespondenceStatus } from '../../../../../../../../shared/enums/admin-panel-correspondence-status.enum';

@Pipe({
  name: 'adminPanelUserCorrespondenceStatusBadgeClass',
  standalone: true,
})
export class AdminPanelUserCorrespondenceStatusBadgeClassPipe
  implements PipeTransform
{
  transform(
    status:
      | keyof typeof AdminPanelCorrespondenceStatus
  ): string {
    switch (status) {
      case 'ODEBRANY':
        return 'status-badge status-received';
      case 'WYSLANY':
        return 'status-badge status-sent';
      case 'ROBOCZY':
        return 'status-badge status-draft';
      case 'OCZEKUJACY_NA_ODBIOR':
        return 'status-badge status-awaiting-receipt';
      default:
        return 'status-badge';
    }
  }
}
